export const border_width_1 = '1px'
export const border_width_2 = '2px'
export const border_width_3 = '3px'

export const border_radius_1 = '4px' //rounded
export const border_radius_2 = '50%' //circle
export const border_radius_3 = '25% / 50%' //pill
